import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import mammoth from 'mammoth';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const TEXT_EXTENSIONS = [
  'txt', 'md', 'csv', 'log', 'json', 'yaml', 'yml', 'xml', 'html', 'htm', 'js', 'ts',
];

function getExtension(name) {
  const idx = name.lastIndexOf('.');
  return idx >= 0 ? name.slice(idx + 1).toLowerCase() : '';
}

async function extractPdfText(arrayBuffer) {
  const pdf = await pdfjsLib.getDocument({ data: new Uint8Array(arrayBuffer) }).promise;
  let text = '';
  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum += 1) {
    const page = await pdf.getPage(pageNum);
    const content = await page.getTextContent();
    const pageText = content.items.map((item) => item.str).join(' ');
    text += `${pageText}\n`;
  }
  return text.trim();
}

export async function extractTextFromFile(file) {
  const ext = getExtension(file.name);
  const type = file.type || '';

  if (ext === 'pdf' || type === 'application/pdf') {
    const text = await extractPdfText(await file.arrayBuffer());
    if (!text) {
      throw new Error('Could not read text from this PDF (it may be a scanned image or password-protected). Please paste the text instead.');
    }
    return text;
  }

  if (ext === 'docx' || type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    const result = await mammoth.extractRawText({ arrayBuffer: await file.arrayBuffer() });
    const text = (result.value || '').trim();
    if (!text) {
      throw new Error('Could not read text from this Word document. Please paste the text instead.');
    }
    return text;
  }

  if (ext === 'doc' || type === 'application/msword') {
    throw new Error('Legacy .doc files are not supported. Please save as .docx or .txt and re-upload, or paste the text.');
  }

  if (TEXT_EXTENSIONS.includes(ext) || type.startsWith('text/') || type === 'application/json') {
    return file.text();
  }

  throw new Error('Unsupported file type. Please upload a .txt, .pdf, or .docx file, or paste the text directly.');
}
